var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1804 2.34323C17.5287 2.63927 16.8274 2.83864 16.0918 2.92866C16.8427 2.46828 17.4194 1.73967 17.6906 0.871481C16.9887 1.29802 16.2094 1.60675 15.3816 1.7741C14.7181 1.05152 13.7722 0.599609 12.727 0.599609C10.7187 0.599609 9.09037 2.26468 9.09037 4.31824C9.09037 4.60945 9.12287 4.8934 9.1849 5.16588C6.16218 5.01122 3.48273 3.53041 1.68895 1.2805C1.37581 1.82969 1.19678 2.46829 1.19678 3.14979C1.19678 4.43968 1.83784 5.57793 2.8145 6.24492C2.21776 6.2256 1.65764 6.05824 1.16665 5.77971V5.82624C1.16665 7.62845 2.421 9.13101 4.08361 9.47357C3.77874 9.55816 3.45733 9.60408 3.12587 9.60408C2.89131 9.60408 2.66324 9.58051 2.44108 9.53701C2.90371 11.0142 4.24728 12.0896 5.8384 12.1198C4.5941 13.1166 3.02602 13.7117 1.32204 13.7117C1.0278 13.7117 0.738295 13.6942 0.454102 13.6593C2.06354 14.7141 3.9749 15.3304 6.02865 15.3304C12.7175 15.3304 16.3754 9.66388 16.3754 4.75021C16.3754 4.5889 16.3724 4.4282 16.3647 4.26931C17.0761 3.74369 17.6929 3.08876 18.1804 2.34323Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9aaf3cab0456913420baaf7835be4c6d.svg";
export { ForwardRef as ReactComponent };